
import { useCallback, useContext, useMemo, useState } from 'react'
import { Button, Loader } from '../../atoms'
import './AsideMenu.css'
import mockMessage from '../../../jsonMock/mockMessage.json'
import { useLocation, useNavigate } from 'react-router-dom'
import { AppGeneralContext } from '../../../shared/GeneralContext/GeneralContext'
import leftArrow from '../../../img/icons/leftArrow.png'
import pinkIcon from '../../../assets/logo192.png'
import GearIcon from '../../atoms/iconsComponent/GearIcon'
import CardPreview from '../../atoms/CardPreview'
import { ChatCard } from '../ChatCard'
import { useEffect } from 'react'
import { LoginType } from '../../types/Context'
import { MatchListReq, MessagesListReq } from 'components/types/Api'
import * as Yup from "yup";
import { Match, ModalType } from 'components/types/types'

import { useAuth } from 'shared/auth'
import XmarkIcon from 'components/atoms/iconsComponent/XmarkIcon'
import { postMatchRead } from 'api/Api'
import { PagerComponent } from '../pagination/PagerComponent'
import { PAGE_SIZE } from 'shared/const'


const userInfoSchema = Yup.object().shape({
  search: Yup.string()
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
})

const AsideMenu = () => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false)
  const {
    loginType,
    setChatIsOpen,
    setReqMessagesList,
    reqMessagesList,
    reqMatchList,
    setReqMatchList,
    getMatchList,
    matchList,
    setMatchSelected,
    setMenuIsOpen,
    setModal,
    setErrorModal,
    pagerMatchList,
    isLoadingMatch
  } = useContext(AppGeneralContext)
  const [filterByText, setFilterByText] = useState<string>("")
  const { logout } = useAuth()
  //factory === true => corporates
  const message = useMemo(() => matchList, [matchList])
  const location = useLocation()

  const [pageSize, setPageSize] = useState(8) 



  const updatePage = useCallback(
    (n: number) => {
      setReqMatchList({ ...reqMatchList, pageNum: n })
    }, [reqMatchList])


  useEffect(() => {
    getMatchList()
  }, [reqMatchList])

  useEffect(() => {
    let RequestMatchList: MatchListReq = { ...reqMatchList, searchText: filterByText }
    setReqMatchList(RequestMatchList)
  }, [filterByText])


  const clickHandler = (id: string, match: Match) => {
    setChatIsOpen(true)
    let RequestMessageList: MessagesListReq = { ...reqMessagesList, matchId: id }
    setReqMessagesList(RequestMessageList)
    postMatchRead({ matchId: id }).then((res) => {
      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return false
      }
      getMatchList()
    })



    setMatchSelected(match)
  }

  useEffect(() => {

    if (location.pathname.toLowerCase().includes('profile/upgrade-plan')) {
      setShowMenu(true)
    }


  if(location.pathname.toLowerCase().includes('corporate')){

    if(!location.pathname.toLowerCase().includes('corporate/edit-profile')){
      setShowMenu(false)
    }
  }


  if(location.pathname.toLowerCase().includes('start-up/profile')){
    setShowMenu(false)
  }

  if(location.pathname.toLowerCase().includes('start-up/profile/billings')){
    setShowMenu(true)
  }

  if(location.pathname.toLowerCase().includes('start-up/profile/services')){
    setShowMenu(true)
  }
  
  }, [location.pathname])


  const openMenu = () => {
    let route = loginType === LoginType.startup ? "start-up" : "corporate"

    if (showMenu) {
      return navigate(`${route}/profile`)
    }

    if (loginType === LoginType.corporate && !showMenu) {
      return navigate("corporate/edit-profile")
    }

    return

  }

  const showMenuProfile = useMemo(() => {

    if (showMenu && loginType === LoginType.startup) {

      return (
        <>
          <div className="d-flex flex-column h-100 mb-3 search-container">
            <div className="d-flex flex-column h-50 edit-button">
              <Button
                background='white'
                text='edit profile'
                onClick={() => { navigate("start-up/edit-profile") }}
                fontWeight='600'
                uppercase />
              <Button
                onClick={() => { navigate("start-up/profile/billings") }}
                background='white'
                text='billings'
                fontWeight='600'
                uppercase />
                <Button
                onClick={() => { navigate("start-up/profile/services") }}
                background='white'
                text='Services'
                fontWeight='600'
                uppercase />
            </div>
            <div className='d-flex flex-column-reverse h-50 edit-button '>
              <Button color='var(--white)'
                background='var(--primary)'
                borderColor='var(--primary)'
                fontWeight={'800'}
                uppercase
                primary
                text='upgrade plan'
                onClick={() => {
                  navigate("/start-up/profile/upgrade-plan")
                }} />
            </div>

          </div>

        </>
      )

    } else {
      return (
        <>
          <div className="d-flex flex-column search-container pt-3">
            <div className=" d-flex w-100 search-info justify-content-between align-items-center">
              <p>Messaging</p>
            </div>
            <div className="relative">
              <input
                placeholder='Search by name'
                className="form-input"
                autoComplete="new-password"
                value={filterByText}
                type="text"
                onChange={(x) => setFilterByText(x.target.value)}
                name="search"
              />
              <div className="delete-input  " onClick={() => setFilterByText("")}>
                <XmarkIcon className='' />
              </div>
            </div>

          </div>
          <div className="d-flex mt-3 flex-column search-result   ">
            {message && message.length !== 0 ?
              message.map((el) => {
                return <CardPreview
                  key={el.id}
                  id={el.id}
                  recipient={loginType === LoginType.startup ? el.company?.name : el.startup?.name}
                  hasImage={loginType === LoginType.startup ? true : false}
                  date={el?.lastMessageDate}
                  department={loginType === LoginType.startup ? el.companyDepartment?.label : el.startup.sector?.label}
                  readMatch={loginType === LoginType.startup ? el?.isReadStartup : el?.isReadCompany}
                  callback={() => {
                    clickHandler(el.id, el)
                  }}
                />
              })
              : <p>{!isLoadingMatch && "You have no messages"}</p>}
          {isLoadingMatch && 
          <div className="loaderCont ">
            <Loader />
            </div>
          } 

          </div>

        </>
      )
    }


  }, [loginType, showMenu, message, isLoadingMatch])

  const logOut = () => {
    logout()
    navigate('/login')
    setMenuIsOpen(false)
  }

  return (
    <aside className="d-flex ps-3 pe-3 flex-column   aside ">
      <div className="d-flex pt-1 pb-1 aside-btn__container justify-content-between align-items-center" >
        <div className='aside-setting d-flex align-items-center justify-content-center' onClick={() => { openMenu(); setShowMenu(x => !x) }}>
          {showMenu ?
            <img src={leftArrow} alt="" />
            :
            <GearIcon className='gear-icon' />
          }
        </div>

        <Button className=' ms-1 aside-logout' color='var(--white)' background='var(--primary)' borderColor='var(--primary)' fontWeight={'400'} uppercase primary text='logout' onClick={() => logOut()} />
      </div>

      {showMenuProfile}
      {/* enable button to switch between corporate-startUp */}
      <ChatCard />
      {!!pagerMatchList && (pagerMatchList?.totalItems ?? 0) > PAGE_SIZE.matchList && !showMenu && (
        <PagerComponent pager={pagerMatchList} onpageChange={(n: number) => { updatePage(n) }} classCss={"mt-5"} />)}
    </aside>
  )
}

export default AsideMenu
